import { Skeleton, TableCell, TableRow } from '@mui/material';
export const APP_VERSION = '5.0.0';

export const masterQueryOptions = {
    staleTime: 600000, // 10 minutes: data is considered fresh for this duration
    cacheTime: 600000, // 10 minutes: unused data stays in cache for this duration
    gcTime: 600000, // 10 minutes: for TanStack Query v5+, controls garbage collection time
};

export const colorArray = ['#C1EFFF', '#FFF0C2', '#CEFFDE', '#FFD4AE', '#CDD4FF', '#FDE2E0', '#A9FFC6', '#FFC1DA', '#DAEFF4'];

export const USER_TIMEZONE = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const PHONE_TYPES = [
    {
        key: 'home',
        value: 'Home',
    },
    {
        key: 'mobile',
        value: 'Mobile',
    },

    {
        key: 'landline',
        value: 'Landline',
    },
    {
        key: 'work',
        value: 'Work',
    },
];

export const PART_TYPES = {
    TYRE: 'tyre',
    PARTS: 'parts',
};
export const SHOP_SERVICE_PRICE_TYPES = {
    FIXED: 'fixed',
    RANGE: 'range',
    NO_PRICE: 'no_price',
    STARTING_FROM: 'starting_from',
};

export const CONTACT_PREFRENCES = [
    {
        key: 'callOnPhone',
        value: 'Phone Call',
    },
    {
        key: 'inAppMessages',
        value: 'In-App Message',
    },
    {
        key: 'email',
        value: 'Email',
    },
];

export const CONTACT_PREFRENCES_SUPPLERS = [
    {
        key: 'callOnPhone',
        value: 'Phone Call',
    },

    {
        key: 'email',
        value: 'Email',
    },
];

export const APPOINTMENT_CONTACT_PREFRENCES = [
    {
        key: 'phone',
        value: 'Phone Call',
    },
    {
        key: 'message',
        value: 'In-App Message',
    },
    {
        key: 'email',
        value: 'Email',
    },
];
export const APPOINTMENT_REQUEST_GENERATED_PLATFORM = {
    CUSTOMER_APP: 'App Booking',
    ONLINE_WEB: 'Online Booking',
};
export const USER_CREATED_FROM = {
    SHOP_CREATED: 'shop_created',
    SHOP_IMPORTED: 'shop_imported',
    SHOP_GUEST: 'shop_guest',
    APEX_AUTO_APP: 'apex_auto_app',
};
export const PAYMENT_TERMS = [
    {
        key: 'none',
        value: 'None',
    },
    {
        key: '30Days',
        value: '30 Days',
    },
    {
        key: 'cashOnDelivery',
        value: 'Cash on Delivery',
    },
    {
        key: '7Days',
        value: '7 Days',
    },
    {
        key: '14Days',
        value: '14 Days',
    },
    {
        key: '21Days',
        value: '21 Days',
    },
    {
        key: '20Days',
        value: '20 Days',
    },
    {
        key: '20DaysEndOfMonth',
        value: '20 Days (After end of month) ',
    },
    {
        key: '30DaysEndOfMonth',
        value: '30 Days (After end of month) ',
    },
    {
        key: '7DaysEndOfMonth',
        value: '7 Days (After end of month) ',
    },
];
export const PAYMENT_STATUS = [
    {
        key: 'paid_in_full',
        value: 'Paid In Full',
    },
    {
        key: 'partial_payment',
        value: 'Partial Payment',
    },
    {
        key: 'open',
        value: 'Open',
    },
];
export const PAYEMNT_METHODS = [
    { key: 'cash', value: 'Cash' },
    { key: 'debit', value: 'Debit' },
    { key: 'credit', value: 'Credit' },
    { key: 'cheque', value: 'Cheque' },
];
export const INVENTORY_TYPES = {
    INVOICE: 'invoice',
    INVENTORY: 'inventory',
    APPOINTMENT: 'appointment',
    SAVED_SERVICE: 'saved_service',
    SUPPLIER: 'supplier_profile',
    SUPPLIER_INVOICE: 'supplier_invoice',
};
export const SAVED_SERVICE_TYPE = {
    INVOICE: 'invoice',
    SAVESERVICE: 'saved_service',
};
export const PARTS_PROVIDER = {
    OEM: 'oem',
    OES: 'oes',
    AFTER_MARKET: 'after_market',
    USED: 'used',
};
export const PRICING_TYPES = {
    FXIED: 'fixed',
    LABOUR: 'labor_&_parts',
    NOPRICE: 'no_price',
};
export const INVENTORY_MANAGE_TYPE = {
    MANAGED: 'managed',
    UNMANAGED: 'unmanaged',
};
export const PARTS_STATUS = {
    BOTH: '',
    IN_STOCK: 'IN_STOCK',
    OUT_OF_STOCK: 'OUT_OF_STOCK',
};

/**
 * Estimate statuses. `work_order` and `invoiced` are set by the backend once the estimate is
 * converted (Estimate → Work Order → Invoice); deleting the invoice moves it back to `work_order`
 * while the work order is still open, otherwise to `sent`.
 */
export const ESTIMATE_STATUS = {
    DRAFT: 'draft',
    SENT: 'sent',
    WORK_ORDER: 'work_order',
    INVOICED: 'invoiced',
};

/**
 * Past draft — sent/finalized, converted to a work order, or invoiced. These all behave like a
 * sent estimate; `isEmailSent` decides between the Sent and the Finalized page.
 */
export const isIssuedEstimate = (status) => [ESTIMATE_STATUS.SENT, ESTIMATE_STATUS.WORK_ORDER, ESTIMATE_STATUS.INVOICED].includes(status);

/**
 * Work Order statuses (five — see docs/work-orders/WORK_ORDERS_SPEC.md §4.1).
 * `open` also covers a previously-authorized work order that has been edited:
 * the record keeps `isPreviouslyAuthorized` so cancel/delete knows to return stock.
 */
export const WORK_ORDER_STATUS = {
    DRAFT: 'draft',
    OPEN: 'open',
    AUTHORIZED: 'authorized',
    // Returned by the list API and accepted as a filter value. Not yet treated as a full
    // lifecycle status — pending client confirmation (spec §12 Q14).
    REAPPROVAL: 'reapproval',
    INVOICED: 'invoiced',
    CANCELLED: 'cancelled',
};

/**
 * The list API still returns the legacy work-order-authorization vocabulary.
 * Map it onto the statuses the UI knows about.
 *   pending      → not yet authorized
 *   approved     → authorized by the customer
 *   reauthorized → authorized, then edited (see spec §12 Q14)
 */
export const WORK_ORDER_STATUS_ALIAS = {
    pending: WORK_ORDER_STATUS.OPEN,
    approved: WORK_ORDER_STATUS.AUTHORIZED,
    authorised: WORK_ORDER_STATUS.AUTHORIZED,
    reauthorized: WORK_ORDER_STATUS.REAPPROVAL,
    reauthorised: WORK_ORDER_STATUS.REAPPROVAL,
    reauthorization: WORK_ORDER_STATUS.REAPPROVAL,
};

/** Normalise a status coming off the API before it is rendered or compared. */
export const normalizeWorkOrderStatus = (status) => WORK_ORDER_STATUS_ALIAS[status] || status;

/**
 * The value `change-status` expects when moving a work order into a status.
 * The API uses the British spelling ("authorised"); the UI uses the American one throughout,
 * so translate on the way out — the mirror of WORK_ORDER_STATUS_ALIAS on the way in.
 */
export const WORK_ORDER_API_STATUS = {
    [WORK_ORDER_STATUS.AUTHORIZED]: 'authorised',
    [WORK_ORDER_STATUS.CANCELLED]: 'cancelled',
};

/** Activity actions returned by the work order history endpoint (spec §14.9). */
export const WOA_ACTION = {
    DRAFT: 'draft',
    CREATE: 'create',
    CREATE_FROM_ESTIMATE: 'create_from_estimate',
    UPDATE: 'update',
    PRINT: 'print',
    DOWNLOAD: 'download',
    AUTHORISED: 'authorised',
    REAUTHORISED: 'reauthorised',
    // The backend's code for a cancelled work order.
    DECLINED: 'declined',
    CONVERTED_TO_INVOICE: 'converted_to_invoice',
    INVOICE_DELETED: 'invoice_deleted',
    // Only ever sent with isEdited: true.
    REAUTHORIZATION: 'reauthorization',
    CANCELLATION_REMOVED: 'cancellation_removed',
    INVOICE_UNLINKED: 'invoice_unlinked',
    EMAIL_SENT: 'email_sent',
    EMAIL_RESENT: 'email_resent',
};

/**
 * History titles, as the backend defines them. The same action code reads differently when the
 * entry is an edit of an existing work order (`isEdited: true`) rather than a plain status step.
 * The modal shows the API's own `title`; these are the fallback when it is missing.
 */
export const WOA_HISTORY_TITLE = {
    standard: {
        [WOA_ACTION.DRAFT]: 'Saved as draft',
        [WOA_ACTION.CREATE]: 'Work Order created',
        [WOA_ACTION.CREATE_FROM_ESTIMATE]: 'Work Order created from Estimate',
        [WOA_ACTION.UPDATE]: 'Work Order updated',
        [WOA_ACTION.PRINT]: 'Work Order PDF printed',
        [WOA_ACTION.DOWNLOAD]: 'Work Order PDF downloaded',
        [WOA_ACTION.AUTHORISED]: 'Customer authorization confirmed',
        [WOA_ACTION.REAUTHORISED]: 'Work Order reauthorized by customer after changes',
        [WOA_ACTION.DECLINED]: 'Work Order cancelled',
        [WOA_ACTION.INVOICE_DELETED]: 'Invoice unlinked after Work Order changes',
        [WOA_ACTION.CONVERTED_TO_INVOICE]: 'Work Order converted to Invoice',
        [WOA_ACTION.EMAIL_SENT]: 'Work order sent to customer',
        [WOA_ACTION.EMAIL_RESENT]: 'Work order resent to customer',
    },
    edited: {
        [WOA_ACTION.DRAFT]: 'Edited and saved as draft',
        [WOA_ACTION.UPDATE]: 'Work Order edited',
        [WOA_ACTION.PRINT]: 'Work Order PDF printed',
        [WOA_ACTION.REAUTHORIZATION]: 'Authorization removed after Work Order edited',
        [WOA_ACTION.CANCELLATION_REMOVED]: 'Cancellation removed after Work Order edited',
        [WOA_ACTION.INVOICE_UNLINKED]: 'Invoice unlinked after Work Order changes',
        [WOA_ACTION.INVOICE_DELETED]: 'Invoice unlinked after Work Order changes',
    },
};

/**
 * Actions that can be registered against a work order (`register-action/:type/:id`).
 * These are recorded for the history — they do not change the work order's status.
 */
export const WOA_REGISTER_ACTION = {
    DOWNLOAD: 'download',
    SHARE: 'share',
};

export const WORK_ORDER_STATUS_LABEL = {
    [WORK_ORDER_STATUS.DRAFT]: 'Draft',
    [WORK_ORDER_STATUS.OPEN]: 'Open',
    [WORK_ORDER_STATUS.AUTHORIZED]: 'Authorized',
    [WORK_ORDER_STATUS.REAPPROVAL]: 'Reapprove',
    [WORK_ORDER_STATUS.INVOICED]: 'Invoiced',
    [WORK_ORDER_STATUS.CANCELLED]: 'Cancelled',
};

/** Chip colours for the work order listing. Cancelled is the only chip with white text. */
export const WORK_ORDER_STATUS_COLOR = {
    [WORK_ORDER_STATUS.OPEN]: { bg: '#FFA429', color: '#000' },
    [WORK_ORDER_STATUS.INVOICED]: { bg: '#1B7130', color: '#fff' },
    [WORK_ORDER_STATUS.DRAFT]: { bg: '#FDD79C', color: '#000' },
    [WORK_ORDER_STATUS.AUTHORIZED]: { bg: '#BCF3CC', color: '#000' },
    [WORK_ORDER_STATUS.REAPPROVAL]: { bg: '#9FE5FA', color: '#000' },
    [WORK_ORDER_STATUS.CANCELLED]: { bg: '#EA4335', color: '#FFF' },
};

/** Default authorization wording seeded into a new work order. */
export const WORK_ORDER_AUTHORIZATION_TEXT = (shopName = 'the shop') =>
    `I have authorized the above repair work performed along with the necessary materials. ${shopName} and its employees were permitted to operate the vehicle for purposes of testing, inspection or delivery at my risk. An express mechanic's lien is acknowledged on the above vehicle to secure the amount of repairs, thereto, ${shopName} is not held responsible for any loss or damage to vehicle or any article within the case of fire, theft or any other cause beyond the control of ${shopName}.`;

export const INVETORY_CASE = {
    CASE_1: 'case_1',
    CASE_2: 'case_2',
};

export const formatConstant = (constant, value, capitalizeOption = 'first') => {
    // Find the key corresponding to the value
    const key = Object.keys(constant).find((k) => constant[k] === value);

    if (!key) {
        return 'INVALID VALUE'; // Handle invalid values
    }

    const formattedKey = key
        .split('_') // Split on underscores
        .map(
            (word) =>
                capitalizeOption === 'uppercase'
                    ? word.toUpperCase() // Convert the whole word to uppercase
                    : word.charAt(0).toUpperCase() + word.slice(1) // Capitalize the first letter only
        )
        .join(' '); // Join with spaces

    return formattedKey;
};

export const TableRowsLoader = ({ height = '', rowsNum, cellsNum = 8 }) => {
    return [...Array(rowsNum)].map((_, rowIndex) => (
        <TableRow key={rowIndex} sx={{ height: height }}>
            {[...Array(cellsNum)].map((_, cellIndex) => (
                <TableCell key={cellIndex}>
                    <Skeleton animation="wave" variant="text" />
                </TableCell>
            ))}
        </TableRow>
    ));
};

export const DEFAULT_EMAIL_MESSAGES = {
    OPENING: (shopName) =>
        `Thank you for choosing ${shopName} for your recent car service needs. Your satisfaction is our priority, and we take pride in delivering exceptional service every time.`,
    CLOSING: 'We truly appreciate your business and look forward to serving you again.',

    RECOMMENDATION_USA: 'E.g. Oil change due at 5,000 mi. Recommend rear brake inspection at next visit.',
    RECOMMENDATION_CANADA: 'E.g. Oil change due at 8,000 km. Recommend rear brake inspection at next visit.',
};

export const RECOMMENDATION_MESSAGES = {
    miles: 'E.g. Oil change due at 5,000 mi. Recommend rear brake inspection at next visit.',
    km: 'E.g. Oil change due at 8,000 km. Recommend rear brake inspection at next visit.',
};

export const APPOINTMENT_REVIEW_PLATFORM = {
    APEX_AUTO: 'apex_auto',
    GOOGLE: 'google',
};

export const INVENTORY_STATUS = {
    TRACKED: 'tracked',
    UNTRACKED: 'untracked',
    COLORS: {
        TRACKED: '#96F6C6',
        UNTRACKED: '#E1E1E1',
    },
};

export const MILEAGE_UNIT = {
    MILES: 'miles',
    KM: 'km',
};

// --- Invoice preview mock data -------------------------------------------------
// Two datasets: Canadian shops (GST/HST + PST) and US shops (Sales Tax and local
// district taxes). The templates pick one via the shop's country code, so the
// preview mirrors what the real PDF will render for that shop.

const CA_TAXES = {
    gst: { taxId: 'sample-gst', taxName: 'GST', taxCode: 'GST', invoiceRate: 5, applyTax: true, customChange: false },
    pst: { taxId: 'sample-pst', taxName: 'PST', taxCode: 'PST', invoiceRate: 7, applyTax: true, customChange: false },
};

const US_TAXES = {
    sales: { taxId: 'sample-sales', taxName: 'Sales Tax', taxCode: 'Sales', invoiceRate: 5, applyTax: true, customChange: false },
    srTax: { taxId: 'sample-srtax', taxName: 'Scientific Research Tax', taxCode: 'SRTax', invoiceRate: 7, applyTax: true, customChange: false },
    scfTax: { taxId: 'sample-scf', taxName: 'Scientific & Cultural Fac.(cd)', taxCode: 'S&CF', invoiceRate: 7, applyTax: true, customChange: false },
    rtdTax: { taxId: 'sample-rtd', taxName: 'Rtd Greater Denver', taxCode: 'RtdGD', invoiceRate: 7, applyTax: true, customChange: false },
};

const BRAKE_FLUID_DESCRIPTION =
    'Synthetic brake fluid based on glycol ethers and their boric acid esters. Has a high boiling point and wet boiling point, thus ensuring safe braking even after the absorption of some moisture over an extended period of use';

/**
 * Line items are identical between countries — only the taxes applied to each
 * line differ, so both datasets share this builder.
 */
const buildSampleServices = (lineTaxes) => [
    {
        serviceId: 'service-1',
        name: 'Replaced Front Brake Pads And Coated Rotors',
        pricingType: 'labor_&_parts',
        serviceDescription: 'Customer complained about grinding noise from front driver side',
        items: [
            { type: 'labor', quantity: 2, cost: '$96.00', amount: '$192.00', taxesBreakdown: lineTaxes.labour1 },
            { type: 'parts', partName: 'Coated Brake Rotors', quantity: 2, cost: '$135.72', amount: '$271.44', taxesBreakdown: lineTaxes.rotors },
            { type: 'parts', partName: 'Brake Lube Kit', quantity: 1, cost: '$10.97', amount: '$10.97', taxesBreakdown: lineTaxes.lubeKit },
            {
                type: 'parts',
                partName: 'Brake Fluid',
                partNumber: 'PRT-0118',
                brand: 'Liqui Moly',
                partsProvider: 'After Market',
                description: BRAKE_FLUID_DESCRIPTION,
                quantity: 2,
                cost: '$8.95',
                amount: '$17.90',
                taxesBreakdown: lineTaxes.brakeFluid,
            },
        ],
        serviceTotal: '$492.31',
    },
    {
        serviceId: 'service-2',
        name: 'Engine Oil Change',
        pricingType: 'labor_&_parts',
        serviceDescription: 'Customer requested routine engine oil and filter replacement',
        items: [
            { type: 'labor', quantity: 1, cost: '$25.00', amount: '$25.00', taxesBreakdown: lineTaxes.labour2 },
            { type: 'parts', partName: 'Oil Filter', quantity: 1, cost: '$5.98', amount: '$5.98', taxesBreakdown: lineTaxes.oilFilter },
            { type: 'parts', partName: 'Environmental Fee', quantity: 1, cost: '$4.95', amount: '$4.95', taxesBreakdown: lineTaxes.envFee },
            { type: 'parts', partName: 'Engine Oil', quantity: 4.2, cost: '$5.95', amount: '$24.99', taxesBreakdown: lineTaxes.engineOil },
        ],
        serviceTotal: '$60.92',
    },
];

/** Fields every shop shares, regardless of country. */
const SAMPLE_SHOP_COMMON = {
    invoiceId: '6a02d879afbfa59683f3e010',
    isDraft: false,
    invoiceNumber: 'INV26-1231',
    createdAt: '2026-05-12',
    invoicePreparedBy: '',
    serviceAdvisor: { name: 'Bob Smith' },
    serviceTechnician: { name: 'John Doe' },
    dates: {
        invoiceDate: '17-May-2026',
        droppedOff: '17-May-2026',
        workCompletion: '20-May-2026',
    },
    shopName: 'Auto Repair Shop Name',
    shopAddressLine1: 'Repair Shop Full Address',
    shopLogo: 'https://dns82ajnfncm5.cloudfront.net/shopLogo/1751017179899.png',
    circleLogo: 'https://dns82ajnfncm5.cloudfront.net/shopLogo/1751017179899.png',
    squareLogo: 'https://dns82ajnfncm5.cloudfront.net/shopLogo/square/1751017181490.png',
    shopPhone: '(416)-123-2780',
    shopEmail: 'autorepair@apex.com',
    shopWebsite: 'www.autorepair.com',
    formattedShopOwnerPhoneNumber: '(416)-123-2780',
    customer: {
        name: 'Michael Jeffrey Smith',
        company: 'ABCD Inc.',
        phone: '(416)-123-2780',
        email: 'michael00@gmail.com',
        formattedCustomerPhoneNumber: '(416)-123-2780',
        poNumber: '8448456',
        taxExemptionNumber: '345667',
        isFleetCustomer: true,
        customerAddressLine1: '456 Warren St. Apt 3A',
        customerAddressLine2: 'Brooklyn, NY 11217',
        customerAddressLinesCombined: '456 Warren St. Apt 3A, Brooklyn, NY 11217',
    },
    displayVehicle: '2023 Audi Q5',
    vehicle: {
        year: 2023,
        vin: '3G1BE6SM0JS588515',
        make: 'Audi',
        model: 'Q5',
        modelTrim: '',
        licenseNumber: 'CLDM 308',
        provinceCode: 'ON',
        odoDroppedOff: '55,000',
        odoReturned: '55,000',
        isFleetCustomer: true,
        fleetUnitNumber: 'FTGUY',
    },
    shouldIncludeTaxInInvoice: true,
    paymentStatus: 'fullyPaid',
    warrantyTitle: 'Please retorque wheels after 150 KM or one week.',
    warrantyDescription:
        'I authorize you to supply the parts and complete the service as described above. I hereby acknowledge my indebtedness in the amount of this invoice on any balance therein and in case of non payment, the right to seize upon the article pursuant to the Repair and Storage Liens Act.',
};

// --- Canadian shop -------------------------------------------------------------

const CA_LINE_TAXES = {
    labour1: [
        { ...CA_TAXES.gst, taxAmount: 9.6 },
        { ...CA_TAXES.pst, taxAmount: 13.44 },
    ],
    rotors: [
        { ...CA_TAXES.gst, taxAmount: 13.57 },
        { ...CA_TAXES.pst, taxAmount: 19.0 },
    ],
    lubeKit: [
        { ...CA_TAXES.gst, taxAmount: 0.55 },
        { ...CA_TAXES.pst, applyTax: false, taxAmount: 0 },
    ],
    brakeFluid: [
        { ...CA_TAXES.gst, taxAmount: 0.9 },
        { ...CA_TAXES.pst, applyTax: false, taxAmount: 0 },
    ],
    labour2: [
        { ...CA_TAXES.gst, taxAmount: 1.25 },
        { ...CA_TAXES.pst, taxAmount: 1.75 },
    ],
    oilFilter: [
        { ...CA_TAXES.gst, taxAmount: 0.3 },
        { ...CA_TAXES.pst, taxAmount: 0.42 },
    ],
    envFee: [
        { ...CA_TAXES.gst, taxAmount: 0.25 },
        { ...CA_TAXES.pst, taxAmount: 0.35 },
    ],
    engineOil: [
        { ...CA_TAXES.gst, taxAmount: 1.25 },
        { ...CA_TAXES.pst, applyTax: false, taxAmount: 0 },
    ],
};

export const invoiceSampleDataCA = {
    ...SAMPLE_SHOP_COMMON,
    countryCode: 'CA',
    shopAddress: '614 Danforth Road',
    shopCityName: 'New Toronto',
    shopProvinceName: 'Ontario',
    shopPostalCode: 'M1K 1E9',
    shopFullAddress: '614 Danforth Road, New Toronto, Ontario, M1K 1E9',
    shopAddressLine2: 'City, Province, Postal Code',
    shopAddressLinesCombined: '614 Danforth Road, New Toronto, ON, M1K 1E9',
    businessRegistrationNumber: '000000000RT0001',
    recommendationNotes: 'Front brakes measure 6mm, Rear brakes measure 8mm. Next oil change due @ 55,000 km',
    services: buildSampleServices(CA_LINE_TAXES),
    fees: [
        {
            description: 'Credit Card Surcharge Fee (3%)',
            cost: '$10.50',
            taxesBreakdown: [
                { ...CA_TAXES.gst, taxAmount: 0.53 },
                { ...CA_TAXES.pst, taxAmount: 0.74 },
            ],
        },
        {
            description: 'Tire Disposal Fee',
            cost: '$4.95',
            taxesBreakdown: [
                { ...CA_TAXES.gst, taxAmount: 0.25 },
                { ...CA_TAXES.pst, taxAmount: 0.35 },
            ],
        },
        {
            description: 'Environmental Fee',
            cost: '$4.95',
            taxesBreakdown: [
                { ...CA_TAXES.gst, taxAmount: 0.25 },
                { ...CA_TAXES.pst, taxAmount: 0.35 },
            ],
        },
    ],
    singleTaxLineOnPdf: false,
    combinedTaxLabel: 'Sales Tax',
    combinedTaxPercentage: 12,
    combinedTaxAmount: '$116.45',
    totals: {
        laborTotal: '$100.00',
        partsTotal: '$850.00',
        servicePackageTotal: '$50.00',
        subTotal: '$1,000.00',
        feesTotal: '$20.40',
        discount: { description: 'Family and Friends', discountPercentage: 5, amount: '$50.00' },
        tax: '$116.45',
        taxesBreakdown: [
            {
                taxId: 'sample-gst',
                taxName: 'GST',
                taxCode: 'GST',
                taxPercentage: 5,
                taxAmount: 48.52,
                appliesToParts: true,
                appliesToLabour: true,
                appliesToFees: true,
                appliesToServicePackage: true,
                applyTax: true,
                taxableAmount: 970.4,
                appliesTaxItemCount: 11,
                totaItemCount: 11,
            },
            {
                taxId: 'sample-pst',
                taxName: 'PST',
                taxCode: 'PST',
                taxPercentage: 7,
                taxAmount: 67.93,
                appliesToParts: true,
                appliesToLabour: true,
                appliesToFees: true,
                appliesToServicePackage: true,
                applyTax: true,
                taxableAmount: 970.4,
                appliesTaxItemCount: 8,
                totaItemCount: 11,
            },
        ],
        total: '$1,086.85',
    },
    payments: [{ paymentDate: '26-Jan-2025', paymentMethod: 'Cash', amount: '$1,086.85' }],
    totalAmountPending: '$0.00',
};

// --- US shop -------------------------------------------------------------------

const US_LINE_TAXES = {
    labour1: [{ ...US_TAXES.sales, taxAmount: 9.6 }],
    rotors: [{ ...US_TAXES.srTax, taxAmount: 19.0 }],
    lubeKit: [
        { ...US_TAXES.sales, taxAmount: 0.55 },
        { ...US_TAXES.srTax, taxAmount: 0.77 },
        { ...US_TAXES.scfTax, taxAmount: 0.77 },
        { ...US_TAXES.rtdTax, taxAmount: 0.77 },
    ],
    brakeFluid: [
        { ...US_TAXES.sales, taxAmount: 0.9 },
        { ...US_TAXES.srTax, taxAmount: 1.25 },
    ],
    labour2: [{ ...US_TAXES.sales, taxAmount: 1.25 }],
    oilFilter: [
        { ...US_TAXES.sales, taxAmount: 0.3 },
        { ...US_TAXES.srTax, taxAmount: 0.42 },
    ],
    envFee: [
        { ...US_TAXES.sales, taxAmount: 0.25 },
        { ...US_TAXES.srTax, taxAmount: 0.35 },
    ],
    engineOil: [{ ...US_TAXES.sales, taxAmount: 1.25 }],
};

export const invoiceSampleDataUS = {
    ...SAMPLE_SHOP_COMMON,
    countryCode: 'US',
    shopAddress: '8001 South Orange Blossom Trail',
    shopCityName: 'Orlando',
    shopProvinceName: 'Florida',
    shopPostalCode: '32809',
    shopFullAddress: '8001 South Orange Blossom Trail, Orlando, Florida, 32809',
    shopAddressLine2: 'City, State, Zip Code',
    shopAddressLinesCombined: '8001 South Orange Blossom Trail, Orlando, FL, 32809',
    ein: '67543678',
    additionalBusinessInfo: [{ value: '56434566776' }],
    recommendationNotes: 'Front brakes measure 6mm, Rear brakes measure 8mm. Next oil change due @ 55,000 mi',
    services: buildSampleServices(US_LINE_TAXES),
    fees: [
        {
            description: 'Environmental Fee',
            cost: '$4.95',
            taxesBreakdown: [
                { ...US_TAXES.sales, taxAmount: 0.25 },
                { ...US_TAXES.srTax, taxAmount: 0.35 },
            ],
        },
    ],
    singleTaxLineOnPdf: false,
    combinedTaxLabel: 'Sales Tax',
    combinedTaxPercentage: 26,
    combinedTaxAmount: '$248.30',
    totals: {
        laborTotal: '$100.00',
        partsTotal: '$850.00',
        servicePackageTotal: '$50.00',
        subTotal: '$1,000.00',
        feesTotal: '$4.95',
        discount: { description: 'Family and Friends', discountPercentage: 5, amount: '$50.00' },
        tax: '$248.30',
        taxesBreakdown: [
            {
                taxId: 'sample-sales',
                taxName: 'Sales Tax',
                taxCode: 'Sales',
                taxPercentage: 5,
                taxAmount: 47.75,
                appliesToParts: true,
                appliesToLabour: true,
                appliesToFees: true,
                appliesToServicePackage: true,
                applyTax: true,
                taxableAmount: 954.95,
                appliesTaxItemCount: 7,
                totaItemCount: 9,
            },
            {
                taxId: 'sample-srtax',
                taxName: 'Scientific Research Tax',
                taxCode: 'SRTax',
                taxPercentage: 7,
                taxAmount: 66.85,
                appliesToParts: true,
                appliesToLabour: false,
                appliesToFees: true,
                appliesToServicePackage: true,
                applyTax: true,
                taxableAmount: 954.95,
                appliesTaxItemCount: 5,
                totaItemCount: 9,
            },
            {
                taxId: 'sample-scf',
                taxName: 'Scientific & Cultural Fac.(cd)',
                taxCode: 'S&CF',
                taxPercentage: 7,
                taxAmount: 66.85,
                appliesToParts: true,
                appliesToLabour: false,
                appliesToFees: false,
                appliesToServicePackage: true,
                applyTax: true,
                taxableAmount: 954.95,
                appliesTaxItemCount: 1,
                totaItemCount: 9,
            },
            {
                taxId: 'sample-rtd',
                taxName: 'Rtd Greater Denver',
                taxCode: 'RtdGD',
                taxPercentage: 7,
                taxAmount: 66.85,
                appliesToParts: true,
                appliesToLabour: false,
                appliesToFees: false,
                appliesToServicePackage: true,
                applyTax: true,
                taxableAmount: 954.95,
                appliesTaxItemCount: 1,
                totaItemCount: 9,
            },
        ],
        total: '$1,203.25',
    },
    payments: [{ paymentDate: '26-Jan-2025', paymentMethod: 'Cash', amount: '$1,203.25' }],
    totalAmountPending: '$0.00',
};

/** Default preview payload; templates swap to the US set for US shops. */
export const invoiceSampleData = invoiceSampleDataCA;

/** Picks the mock payload matching the shop's country. */
export const getInvoiceSampleData = (countryCode) =>
    String(countryCode || '')
        .trim()
        .toUpperCase() === 'US'
        ? invoiceSampleDataUS
        : invoiceSampleDataCA;
export const CHIP_COLOR = {
    DEFAULT_COLOR: 'rgba(0,0,0,0.87)',
    FINALIZED: '#C8F5D1',

    SENT: '#B0E8FC',
    DRAFT: '#FDD79C',
    BALANCE_OWING: '#D32F2F',
    BALANCE_OWING_COLOR: '#fff',

    FULLY_PAID: '#2E7D32',
    FULLY_PAID_COLOR: '#fff',
    BALANCE_REMAINING: '#FFAE00',
    SHOP_CREATED_BG: '#75DBFF80',
    SHOP_CREATED_COLOR: 'rgba(0,0,0,0.87)',
    SHOP_IMPORTED_BG: '#E1D0FD',
    SHOP_IMPORTED_COLOR: '#3E1C76',
    APEX_AUTO_APP_BG: '#EFEFEF',
    APEX_AUTO_APP_COLOR: '#002394',
    FLEET_CUSTOMER: '#FDD79C',
    WALK_IN_BG: '#E1D0FD',
    WALK_IN_COLOR: '#3E1C77',
};

export const INVOICE_PAYMENT_STATUS = {
    UNPAID: 'unpaid',
    PARTIALLY_PAID: 'partiallyPaid',
    FULLY_PAID: 'fullyPaid',
    OVER_PAID: 'overPaid',
};

export const SUPPLIER_INVOICE_STATUS = {
    OPEN: 'open',
    PARTIAL: 'partial_payment',
    FULL: 'paid_in_full',
};

export const SHOP_ID = JSON.parse(localStorage.getItem('apex-saas_details'))?._id;

export const PDF_VISIBILITY_TYPES = {
    INVOICE: 'invoice',
    ESTIMATE: 'estimate',
    WORK_ORDER: 'workOrder',
};

/**
 * Section name each PDF-visibility tab reads and writes on the settings record.
 * Invoice and estimate match their tab value; the work order's section is named
 * `workOrderAuthorization`, after the module the API calls it.
 */
export const PDF_VISIBILITY_SECTION_KEYS = {
    [PDF_VISIBILITY_TYPES.INVOICE]: 'invoice',
    [PDF_VISIBILITY_TYPES.ESTIMATE]: 'estimate',
    [PDF_VISIBILITY_TYPES.WORK_ORDER]: 'workOrderAuthorization',
};

export const PRICING_METHOD = {
    MARKUP: 'markup',
    MARGIN: 'margin',
    RETAIL_PRICE: 'retail_price',
};
